'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _dofOverlay = require('../dof-overlay');

var _dofOverlay2 = _interopRequireDefault(_dofOverlay);

var _dolphinNativeBridge = require('dolphin-native-bridge');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var animation = weex.requireModule('animation');
var platform = weex.config.env.platform;

var isWeb = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && platform.toLowerCase() === 'web';
exports.default = {
  components: { DofOverlay: _dofOverlay2.default },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    pos: {
      type: String,
      default: 'bottom'
    },
    // 背景色  暂不开放
    popupColor: {
      type: String,
      default: '#FFFFFF'
    },
    overlayCfg: {
      type: Object,
      default: function _default() {
        return {
          hasAnimation: true,
          timingFunction: ['ease-in', 'ease-out'],
          duration: 300,
          opacity: 0.3
        };
      }
    },
    height: {
      type: [Number, String],
      default: 840
    },
    standOut: {
      type: [Number, String],
      default: 0
    },
    width: {
      type: [Number, String],
      default: 750
    },
    animation: {
      type: Object,
      default: function _default() {
        return {
          // timingFunction: 'ease-in'
          timingFunction: 'cubic-bezier(0.25, 0.1, 0.25, 1.0)'
        };
      }
    },
    button: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      haveOverlay: true,
      isOverShow: true,
      bottomArc: 0
    };
  },
  computed: {
    isipx: function isipx() {
      if (this.bottomArc) return true;
      return weex && (weex.config.env.deviceModel === 'iPhone10,3' || weex.config.env.deviceModel === 'iPhone10,6' || // iphoneX
      weex.config.env.deviceModel === 'iPhone11,8' || // iPhone XR
      weex.config.env.deviceModel === 'iPhone11,2' || // iPhone XS
      weex.config.env.deviceModel === 'iPhone11,4' || weex.config.env.deviceModel === 'iPhone11,6' || // iPhone XS Max
      weex.config.env.deviceModel === 'iPhone12,1' || // iPhone11
      weex.config.env.deviceModel === 'iPhone12,3' || weex.config.env.deviceModel === 'iPhone12,5') // iPhone 11 Pro iPhone 11 Pro Max
      ;
    },
    isNeedShow: function isNeedShow() {
      var _this = this;

      try {
        setTimeout(function () {
          _this.appearPopup(_this.show);
        }, 50);
      } catch (error) {
        this.$nextTick(function () {
          _this.appearPopup(_this.show);
        });
      }
      return this.show;
    },
    _height: function _height() {
      var height = this.height,
          isipx = this.isipx,
          pos = this.pos;

      height = Number(height);
      height = isipx && pos == 'bottom' ? height + 68 : height;
      this.appearPopup(this.show, 150);
      return height;
    },
    transformValue: function transformValue() {
      return this.getTransform(this.pos, this.width, this.height, true);
    },
    padStyle: function padStyle() {
      var pos = this.pos,
          width = this.width,
          height = this.height,
          popupColor = this.popupColor,
          _height = this._height;

      var style = {
        width: width + 'px',
        backgroundColor: popupColor
      };
      pos === 'top' && (style = _extends({}, style, {
        top: -height + 'px',
        height: height + 'px',
        borderBottomLeftRadius: '32px',
        borderBottomRightRadius: '32px'
      }));
      pos === 'bottom' && (style = _extends({}, style, {
        bottom: -_height + 'px',
        height: _height + 'px',
        borderTopLeftRadius: '32px',
        borderTopRightRadius: '32px'
      }));
      pos === 'left' && (style = _extends({}, style, {
        left: -width + 'px'
      }));
      pos === 'right' && (style = _extends({}, style, {
        right: -width + 'px'
      }));
      return style;
    }
  },
  created: function created() {
    var _this2 = this;

    _dolphinNativeBridge.Bridge.getAllBarHeight().then(function (res) {
      _this2.bottomArc = res.bottomArc || 0;
    });
  },

  methods: {
    actionsheetBtnClick: function actionsheetBtnClick(index, text) {
      this.appearPopup(false);
      this.$refs.overlay.appearOverlay(false);
      this.$emit('dofPopupButtonClicked', { index: index, text: text });
    },
    handleTouchEnd: function handleTouchEnd(e) {
      // 在支付宝上面有点击穿透问题
      var platform = weex.config.env.platform;

      platform === 'Web' && e.preventDefault && e.preventDefault();
    },
    hide: function hide() {
      this.appearPopup(false);
      this.$refs.overlay.appearOverlay(false);
    },
    dofOverlayBodyClicking: function dofOverlayBodyClicking() {
      this.isShow && this.appearPopup(false);
    },
    appearPopup: function appearPopup(bool) {
      var _this3 = this;

      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

      this.isShow = bool;
      var popupEl = this.$refs['dof-popup'];
      if (!popupEl) {
        return;
      }
      animation.transition(popupEl, _extends({
        styles: {
          transform: this.getTransform(this.pos, this.width, this._height, !bool) //_height解决iphonex系列向上过渡距离不够的问题
        },
        duration: duration,
        delay: 0
      }, this.animation), function () {
        if (!bool) {
          _this3.$emit('dofPopupOverlayClicked', { pos: _this3.pos });
        }
      });
    },
    getTransform: function getTransform(pos, width, height, bool) {
      var _size = pos === 'top' || pos === 'bottom' ? height : width;
      var _transform = void 0;
      if (isWeb) {
        _size -= this.standOut;
      }
      bool && (_size = 0);
      switch (pos) {
        case 'top':
          _transform = 'translateY(' + _size + 'px)';
          break;
        case 'bottom':
          _transform = 'translateY(-' + _size + 'px)';
          break;
        case 'left':
          _transform = 'translateX(' + _size + 'px)';
          break;
        case 'right':
          _transform = 'translateX(-' + _size + 'px)';
          break;
      }
      return _transform;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-select-picker/index.vue
// module id = 382
// module chunks = 0 1